import { useContext } from 'react'
import { InhibitKeyPressOverrideContext } from 'providers/InhibitKeyPressOverrideProvider'

export const useInhibitKeyPressOverride = () => {
  return useContext(InhibitKeyPressOverrideContext)
}
